import React from 'react'

import { Route, IndexRoute } from 'react-router'

import { MenuContainer } from './MenuContainer'
import { MenuRecipesPageWrapper } from './MenuRecipesPage'
import { CuratedBoxes } from './components/CuratedBoxes'

export const MenuRoute = (
  <Route path="/menu" component={MenuContainer}>
    <IndexRoute component={MenuRecipesPageWrapper} />
    <Route path="curated-boxes" component={CuratedBoxes} />
    <Route path=":orderId" component={MenuRecipesPageWrapper} />
  </Route>
)
